import React from "react";
import GodisnjiIzvestaj from "../../components/admin/godisnjiIzvestaj";

function GodisnjiIzvestajPage(props) {
  return (
    <div className="admin-page-child-wrapper" style={{ position: "relative" }}>
      <GodisnjiIzvestaj />
    </div>
  );
}

export default GodisnjiIzvestajPage;
